import BTDArtwork from "../assets/album-covers/bucthudau-cover.jpg";
import BTDShare from "../assets/album-covers/bucthudau-share.jpg";
import VMYRArtwork from "../assets/album-covers/viminhyeuroi-cover.jpg";
import CXNAArtwork from "../assets/album-covers/chuyenxengayay-cover.jpg";
import CXNAShare from "../assets/album-covers/chuyenxengayay-share.jpg";
import CXNATeaser from "../assets/album-covers/chuyenxengayay-teaser.jpg";
import TGArtwork from "../assets/album-covers/thoigian-cover.jpg";
import TGShare from "../assets/album-covers/thoigian-share.jpg";
import TG1Artwork from "../assets/album-covers/thoigian-1.jpg";
import TG2Artwork from "../assets/album-covers/thoigian-2.jpg";
import TG3Artwork from "../assets/album-covers/thoigian-3.jpg";
import TG4Artwork from "../assets/album-covers/thoigian-4.jpg";

/*
 * Each key is the URL path for the song page, e.g. /bucthudau.
 *
 * stage: where the release is at. Change it to move the release along; the
 *   home page and the song page follow (see src/utils/releaseStatus.js).
 *   - "teaser": shows only `teaserArtwork` (an already-blurred image), COMING
 *     SOON and "Arriving <year>". No title, preview or streaming links.
 *     Everything in this file ends up in the site's files, so while a release
 *     is a teaser, leave out its real title, cover and preview (the build
 *     warns if they're there).
 *   - "announced": the real title, cover and preview; the streaming buttons
 *     are shown switched off with the release date. On `releaseDate` it turns
 *     into "released" by itself (no need to deploy that day).
 *   - "released" (or no stage): everything works.
 *   - "hidden": off the site (no card, no page, no link preview), but the
 *     data stays here. Its address leads to the home page.
 *   The key is the address (thangcao.me/<key>) once it's announced or
 *   released. A teaser is shown at thangcao.me/soon instead (only one teaser
 *   at a time), so the key can already be the song's name; give it
 *   aliases: ["soon"] when it's revealed, so /soon links forward to it.
 *   Announced: the date shows once on the song page ("Single · Coming
 *   20.11") and as "Coming 20.11" on the home page card; the year is added
 *   only when it isn't the current year ("Coming 15.01.2027") and the buttons say "Coming soon"; without a releaseDate yet it's
 *   "Single · Coming soon".
 *
 * aliases (optional): old addresses that now lead to this release, e.g. the
 *   teaser's ["soon"]: thangcao.me/soon forwards to the song.
 *
 * preview: put the audio file in public/audio/ and set `src` to "/audio/<file>".
 *   (Google Drive links don't work here: Drive blocks audio requests from other websites.)
 *   - For a pre-cut clip, leave start at 0 and duration as null (plays the whole file).
 *   - For a full track, set `start` (seconds) and `duration` (seconds) to the best part.
 *
 * shareImage (optional): a smaller copy of the cover used only for link
 *   previews when the song is shared. Keep it under ~300 KB (WhatsApp skips
 *   bigger images). Without it, the cover itself is used.
 *
 * releaseDate: "YYYY-MM-DD". The newest release is listed first on the home page
 *   with a "Latest" badge.
 *
 * links: leave a platform out (or set it to null) to hide its button.
 *   Shown in this order: youtube, youtubeMusic, spotify, appleMusic, itunes
 *   (iTunes Store), tiktok (the song's TikTok sound), amazonMusic.
 *
 * credits (optional): shown on the song page under "CREDITS +", in this order.
 *   Each role and who did it (one name, or a list for several). Leave a role
 *   out to skip it; without `credits` there's no CREDITS button.
 *   credits: {
 *     "Composed by": "thangcao",
 *     "Produced by": "…",
 *     "Performed by": "thangcao",
 *     "Mixed & mastered by": ["…", "…"],
 *     "Artwork": "…",
 *   },
 *
 * EP or album (several songs): one cover and one set of links for the whole
 * release, and a `tracks` list instead of `preview`, in track order. Each song
 * has its own preview clip (leave `preview` out for a song without one) and,
 * optionally, its own `artwork`: on the release page, choosing a song (or
 * hovering it) shows its art in place of the release cover.
 * A song can also have its own `credits` (same format as below): choosing it
 * shows those in the cover's credits; songs without them show the release's.
 *
 *   myep: {
 *     title: "My EP",
 *     artist: "thangcao",
 *     type: "EP",                      // or "Album"
 *     year: 2026,
 *     releaseDate: "2026-11-20",
 *     artwork: MyEpArtwork,
 *     tracks: [
 *       { title: "First Song", artwork: FirstSongArt, preview: { src: "/audio/myep-1-preview.mp3", start: 0, duration: null } },
 *       { title: "Second Song", preview: { src: "/audio/myep-2-preview.mp3", start: 0, duration: null } },
 *     ],
 *     links: { spotify: "https://open.spotify.com/album/…", … },
 *   },
 */
// THỜI GIAN credits. The songs (and the single chuyến xe ngày ấy) share
// THOIGIAN_SONG_CREDITS; the EP as a whole adds everyone on guitar;
// thatshowitgoes has its own (Sam Ari on guitar).
const THOIGIAN_SONG_CREDITS = {
  "Composed & produced by": "thangcao",
  "Mixed & mastered by": "True Sound Asia",
  "Album cover by": ["Bao Le", "Tyler Le"],
};

const THOIGIAN_EP_CREDITS = {
  "Composed & produced by": "thangcao",
  "Guitar by": ["thangcao", "Sam Ari"],
  "Mixed & mastered by": "True Sound Asia",
  "Album cover by": ["Bao Le", "Tyler Le"],
};

export const SONGS = {
  thoigian: {
    stage: "hidden",
    title: "THỜI GIAN",
    artist: "thangcao",
    type: "EP",
    year: 2027,
    releaseDate: "2027-01-11",
    artwork: TGArtwork,
    shareImage: TGShare,
    tracks: [
      { title: "bức thư đầu (soft ver.)", artwork: TG1Artwork, credits: THOIGIAN_SONG_CREDITS },
      { title: "tỏ bày", artwork: TG2Artwork, credits: THOIGIAN_SONG_CREDITS },
      { title: "thời gian (interlude)", artwork: TG3Artwork, credits: THOIGIAN_SONG_CREDITS },
      {
        title: "thatshowitgoes",
        artwork: TG4Artwork,
        credits: {
          "Composed & produced by": "thangcao",
          "Guitar by": "Sam Ari",
          "Mixed & mastered by": "True Sound Asia",
          "Album cover by": ["Bao Le", "Tyler Le"],
        },
      },
      { title: "chuyến xe ngày ấy", artwork: CXNAArtwork, credits: THOIGIAN_SONG_CREDITS },
    ],
    credits: THOIGIAN_EP_CREDITS,
    links: {},
  },
  chuyenxengayay: {
    stage: "teaser",
    teaserArtwork: CXNATeaser, // blurred cover for the COMING SOON stage
    title: "chuyến xe ngày ấy",
    artist: "thangcao",
    type: "Single",
    year: 2026,
    releaseDate: "2026-11-20",
    aliases: ["soon"], // once revealed, /soon (the teaser's address) forwards here
    artwork: CXNAArtwork,
    shareImage: CXNAShare,
    credits: THOIGIAN_SONG_CREDITS,
    links: {},
  },
  bucthudau: {
    title: "Bức Thư Đầu",
    artist: "thangcao",
    type: "Single",
    year: 2023,
    releaseDate: "2023-12-02",
    artwork: BTDArtwork,
    shareImage: BTDShare,
    preview: {
      src: "/audio/bucthudau-preview.mp3",
      start: 0,
      duration: null,
    },
    credits: {
      "Composed by": "thangcao",
      "Produced & mixed by": "thangcao",
      "Mastered by": "Bryan Shortell",
    },
    links: {
      spotify: "https://open.spotify.com/track/2PanRs5h9CQe50SBxTwSv7",
      appleMusic:
        "https://music.apple.com/us/album/b%E1%BB%A9c-th%C6%B0-%C4%91%E1%BA%A7u-single/1718564618",
      itunes: "https://music.apple.com/us/album/b%E1%BB%A9c-th%C6%B0-%C4%91%E1%BA%A7u-single/1718564618?app=itunes", // iTunes Store (to buy it)
      tiktok: "https://www.tiktok.com/music/B%E1%BB%A9c-Th%C6%B0-%C4%90%E1%BA%A7u-7306188506468157441",
      youtubeMusic:
        "https://music.youtube.com/playlist?list=OLAK5uy_lEbgVCIh1oKKYIpijNdyFm73LlnDVf_9g",
      youtube: "https://www.youtube.com/watch?v=m-i8V3kYrcI",
      amazonMusic: "https://music.amazon.com/albums/B0CP2QT3SX",
    },
  },
  viminhyeuroi: {
    title: "Vì Mình Yêu Rồi",
    artist: "thangcao",
    type: "Single",
    year: 2021,
    releaseDate: "2021-10-01",
    artwork: VMYRArtwork,
    preview: {
      src: "/audio/viminhyeuroi-preview.mp3",
      start: 0,
      duration: null,
    },
    credits: {
      "Composed & produced by": "thangcao",
      "Mixed & mastered by": "thangcao",
    },
    links: {
      spotify: "https://open.spotify.com/track/5aDN4ofNUC1jyf1jmdTpeN",
      appleMusic:
        "https://music.apple.com/us/album/v%C3%AC-m%C3%ACnh-y%C3%AAu-r%E1%BB%93i/1588440435?i=1588440436",
      itunes: "https://music.apple.com/us/album/v%C3%AC-m%C3%ACnh-y%C3%AAu-r%E1%BB%93i/1588440435?i=1588440436&app=itunes", // iTunes Store (to buy it)
      tiktok: "https://www.tiktok.com/music/V%C3%AC-M%C3%ACnh-Y%C3%AAu-R%E1%BB%93i-7008981571378120705",
      youtubeMusic: "https://music.youtube.com/watch?v=1eq8YRbBQgI",
      youtube: "https://youtu.be/l3-KclPEwAk",
      amazonMusic: "https://www.amazon.com/gp/product/B09HN871L5",
    },
  },
};
